import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import './WhyChooseUs.css';

const features = [
  {
    icon: '⏱️',
    title: 'On-Time Delivery',
    description: 'I respect deadlines and deliver projects on schedule, every time.',
  },
  {
    icon: '💻',
    title: 'Modern Tech Stack',
    description: 'Using cutting-edge technologies to build scalable and efficient solutions.',
  },
  {
    icon: '🎨',
    title: 'Creative UI/UX',
    description: 'Designs that are not just beautiful but also intuitive and user-friendly.',
  },
  {
    icon: '🛟',
    title: '24×7 Support',
    description: 'Dedicated support to ensure your project runs smoothly.',
  },
];

const FeatureCard = ({ feature, index }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <motion.div
      ref={ref}
      className="feature-card"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ scale: 1.05, y: -5 }}
    >
      <motion.div
        className="feature-icon"
        whileHover={{ rotate: 360, scale: 1.2 }}
        transition={{ duration: 0.5 }}
      >
        {feature.icon}
      </motion.div>
      <h3 className="feature-title">{feature.title}</h3>
      <p className="feature-description">{feature.description}</p>
    </motion.div>
  );
};

const WhyChooseUs = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section className="why-choose-us" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Why Choose Me</h2>
          <p className="section-subtitle">
            What sets me apart in delivering exceptional digital solutions
          </p>
        </motion.div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <FeatureCard key={index} feature={feature} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;

